import React from 'react';
import { Typography } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';
import { useStatusStyle } from '@europrocurement/l2d-modules/hooks';
import { StatusStyleType } from '@europrocurement/l2d-modules/hooks/useStatusStyle';

export type DossierStatusProps = {
    label: string;
    statutId: number;
    handleStyleStatus?: (statutId?: number | null | undefined) => StatusStyleType;
};

const DossierStatus: React.FunctionComponent<DossierStatusProps> = function ({
    label,
    statutId,
    handleStyleStatus,
}) {
    const { getDossierStatusStyle } = useStatusStyle();

    const { iconProp, sxStatus } =
        handleStyleStatus && typeof handleStyleStatus !== 'undefined'
            ? handleStyleStatus(statutId)
            : getDossierStatusStyle(statutId);

    return (
        <InformationChip
            icon={iconProp}
            sx={{ ...sxStatus, display: 'flex', alignItems: 'center' }}
            sxIcon={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            label={<Typography variant="l2dbodys">{label}</Typography>}
        />
    );
};

export default DossierStatus;
